import { render, staticRenderFns } from "./DragMode.vue?vue&type=template&id=1639aa9d&scoped=true"
import script from "./DragMode.vue?vue&type=script&lang=ts"
export * from "./DragMode.vue?vue&type=script&lang=ts"
import style0 from "./DragMode.vue?vue&type=style&index=0&id=1639aa9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1639aa9d",
  null
  
)

export default component.exports